<template>
<div class="appsettings_component page-wrap center-item-to-body">
  <div class="container-box">
    <div class="container-box__logo">
      <router-link to="/">
        <img alt="beurer logo" class="logo_src" src="@/assets/logo_beurer.png">
      </router-link>
    </div>
    <div class="container-box__content">
      <div class="settings-content content-column">
        <div class="logo-container component-holder">
          <TheLogoUploader :logoSrc="this.appLogoUrl" />
        </div>
        <div class="app-colors component-holder">
          <TheAppColorpicker :primaryColor="this.appColors.primary" :secondaryColor="this.appColors.secondary" />
        </div>
      </div>
      <div class="settings-list content-column">
        <h1 class="settings-list__title" :style="{color: this.appColors.primary}">{{ this.appName }}</h1>
        <h2>Documents</h2>
        <div class="settings-list__child" v-for="(item, key) in appDocumentList" :key="key">
          <div class="app-document-title">
            <TheCategoryCheckbox :inputId="item.documentId" :inputValue="item.title" :inputEnabled="item.enabled" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  createNamespacedHelpers
} from 'vuex'
import {
  appMutations,
  appActions
} from '@/constants/'
import TheLogoUploader from '@/components/TheLogoUploader'
import TheCategoryCheckbox from '@/components/TheCategoryCheckbox'
import TheAppColorpicker from '@/components/TheAppColorpicker.vue'

const {
  mapState
} = createNamespacedHelpers('applicationState')

export default {
  name: 'appsettings',
  components: {
    TheLogoUploader,
    TheCategoryCheckbox,
    TheAppColorpicker
  },
  data: function () {
    return {
      currentApp: this.$route.params.app,
      name: '',
      logoUrl: '',

      colors: {},
      font: ''
    }
  },
  mounted () {
    this.$store.dispatch('applicationState/' + appActions.UPDATE_APP_SETTINGS_FROM_API, this.currentApp)
    this.$store.subscribe(mutation => {
      if (mutation.type === 'applicationState/' + appMutations.SET_APP_SETTINGS_DOCUMENT_LIST) {
        // console.log('listening mutation on AppSettings: SET_APP_SETTINGS_DOCUMENT_LIST')
      }
    })
  },
  created () {},
  methods: {
    getAppSettingsData (log) {
      this.name = this.name === undefined ? this.name : this.appName
      this.logoUrl = this.appLogoUrl === undefined ? this.logoUrl : this.appLogoUrl

      this.colors = this.appColors === undefined ? this.colors : this.appColors
      this.font = this.appFont === undefined ? this.font : this.appFont
    }
  },
  computed: {
    ...mapState({
      appName: state => state.appName,
      appLogoUrl: state => state.appLogoUrl,
      appDocumentList: state => state.appDocumentList,
      appColors: state => state.appColors,
      appFont: state => state.appFont
    })
  }
}
</script>

<style lang="scss">
@import "@/scss/main.scss";

.appsettings_component {
  display: flex;
  justify-content: center;
  align-self: center;
  height: auto;
}

.container-box {
  height: 100%;

  &__content {
    .content-column {
      margin: 0 rem(10) rem(10) rem(10);

      @include breakpoint(tablet) {
        // height: rem(720);
        margin: 0 auto;
      }

      .component-holder {
        margin: 0 rem(5) rem(20) rem(5);
      }
    }

    .settings-content {

      .logo-container {
        width: rem(150);
        height: rem(150);
        margin: auto auto rem(26) auto;
        display: flex;
        justify-content: center;

        @include breakpoint(tablet) {
          width: rem(200);
          height: auto;
        }
      }
    }

    .settings-list {
      border: none;
      width: 100%;
      // height: rem(150);
      text-align: left;
      margin-left: rem(32);

      @include breakpoint(tablet) {
        width: 60%;
        // height: rem(200);
      }

      &__title {}
    }
  }
}
</style>
